import cardiffCarChargingImage from '../../../assets/images/cardiff/car-charging.jpg';
import centralCardiffImage from '../../../assets/images/cardiff/central-cardiff.jpg';
import cardiffSuburbsImage from '../../../assets/images/cardiff/cardiff-suburb-streets.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const cardiff = {
    cityName: 'Cardiff',
    searchQuery: 'Cardiff',
    heroHeading: "Cwtch! Find EV Chargers in Cardiff",
    heroSubheading: "Search for electric vehicle charging points across Wales' capital. From the City Centre to Cardiff Bay, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try a Cardiff postcode, e.g. CF10...",
    networkSection: {
        heading: "Cardiff's Charging Network at Your Fingertips",
        paragraphs: [
            "Cardiff has a growing EV charging network across the city, with public charge points spread throughout the City Centre, suburbs, and surrounding areas.",
            <>By 2030 Cardiff is expected to need around <a href="https://cardiff.moderngov.co.uk/documents/s81506/CAB%2017%20October%202024%20-%20EV%20Infrastructure%20Roadmap.pdf#page=1" target="_blank" rel="noopener noreferrer">5,800 public chargers</a> across the region.</>,
            "EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger for your needs.",
        ],
        image: centralCardiffImage,
        imageAlt: "Electric vehicle charging at a public charge point in Cardiff",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up in the City Centre or a slower overnight charger near your home, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: cardiffCarChargingImage,
        imageAlt: "Cardiff streets for EV navigation",
    },
    navigateSection: {
        heading: "Navigate Cardiff's Streets with Confidence",
        paragraphs: [
            "Driving in Cardiff doesn't need to be stressful when you're worried about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey around the city.",
        ],
        image: cardiffSuburbsImage,
        imageAlt: "EV charging in Cardiff",
    },
    seo: {
        title: "EV Charging Points in Cardiff | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across Cardiff. Search for public EV chargers in City Centre, Cardiff Bay, Treforest, and surrounding areas with EVBuddy.",
        keywords: "EV charging Cardiff, electric vehicle chargers Cardiff, EV charging points Cardiff, public EV chargers Cardiff, Cardiff electric car charging, charge my EV Cardiff, rapid chargers Cardiff",
        canonicalUrl: "https://evbuddy.io/cardiff",
        ogImage: "https://evbuddy.io/static/media/cardiff-city.jpg",
        ogDescription: "Find electric vehicle charging points across Cardiff. Search for public EV chargers with EVBuddy.",
    },
};

export default cardiff;
